import React, { useEffect, useState } from 'react';
import { Card, CardBody, CardHeader, Table, Spinner, Container, Button, Badge } from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { getFaqs, deleteFaqs } from '../../slices/faq/thunk';
import { selectFaqData } from '../../slices/faq/selectors';
import SweetAlert from 'react-bootstrap-sweetalert';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const FAQ = () => {
    document.title = "FAQ Settings";
    const dispatch = useDispatch();
    const [selectedFaqs, setSelectedFaqs] = useState([]);
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);

    const { faqs, loading } = useSelector(selectFaqData);
    
    // Add this to debug the data
    console.log("FAQ List Data:", faqs);

    useEffect(() => {
        dispatch(getFaqs());
    }, [dispatch]);

    const handleSelectFaq = (faqId) => {
        setSelectedFaqs(prev => {
            if (prev.includes(faqId)) {
                return prev.filter(id => id !== faqId);
            }
            return [...prev, faqId];
        });
    };

    const handleDeleteConfirm = () => {
        dispatch(deleteFaqs(selectedFaqs)).then(() => {
            setSelectedFaqs([]);
            setShowDeleteAlert(false);
            dispatch(getFaqs()); // Refresh the list
        }).catch((error) => {
            console.error('Failed to delete FAQs:', error);
            setShowDeleteAlert(false);
        });
    };

    return (
        <React.Fragment>
        <div className="page-content">
            <Container fluid>
                    <BreadCrumb title="FAQ" pageTitle="Settings" />
                        <Card>
                        <CardHeader className="d-flex justify-content-between align-items-center">
                            <h4 className="card-title mb-0">FAQ Settings</h4>
                                                        <div>
                                <Link to="/faq-add">
                                    <Button color="primary" className="me-2">
                                        <i className="ri-add-line align-bottom me-1"></i> Add FAQ
                                                                    </Button>
                                </Link>
                                                                <Button 
                                    color="danger" 
                                    onClick={() => setShowDeleteAlert(true)}
                                    disabled={selectedFaqs.length === 0}
                                >
                                    <i className="ri-delete-bin-line align-bottom me-1"></i> Delete Selected
                                                                </Button>
                                                            </div>
                                                </CardHeader>
                                                <CardBody>
                            {loading ? (
                                <div className="text-center">
                                    <Spinner color="primary" />
                                                            </div>
                            ) : (
                                <Table className="table-nowrap mb-0">
                                    <thead>
                                        <tr>
                                            <th scope="col">
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        checked={faqs?.length > 0 && selectedFaqs.length === faqs.length}
                                                                                    onChange={(e) => {
                                                            if (e.target.checked) {
                                                                setSelectedFaqs(faqs.map(faq => faq._id));
                                                            } else {
                                                                setSelectedFaqs([]);
                                                            }
                                                                                    }}
                                                                                />
                                                                            </div>
                                            </th>
                                            <th scope="col">Title</th>
                                            <th scope="col">Has Sub Category</th>
                                            <th scope="col">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Array.isArray(faqs) && faqs.map((faq) => (
                                            <tr key={faq._id}>
                                                <td>
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            checked={selectedFaqs.includes(faq._id)}
                                                            onChange={() => handleSelectFaq(faq._id)}
                                                                                />
                                                                            </div>
                                                </td>
                                                <td>{faq?.title || 'No Title'}</td>
                                                <td>
                                                    {faq?.hasSubPoint ? (
                                                        <Link to={`/faq-subsections/${faq._id}`} className="text-decoration-none">
                                                            <Badge color="info" className="cursor-pointer">
                                                                {faq.subPointsCount || 0} Subsections
                                                            </Badge>
                                                        </Link>
                                                    ) : 'No'}
                                                </td>
                                                <td>
                                                    <Link 
                                                        to={`/faq-edit/${faq._id}`}
                                                        className="btn btn-sm btn-soft-primary"
                                                    >
                                                        Edit
                                                    </Link>
                                                </td>
                                            </tr>
                                        ))}
                                        {(!Array.isArray(faqs) || faqs.length === 0) && (
                                            <tr>
                                                <td colSpan="4" className="text-center">
                                                    No FAQs found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            )}
                                                    </CardBody>
                                                </Card>
                </Container>
                                                                </div>

            {/* Delete Confirmation Alert */}
            <SweetAlert
                warning
                showCancel
                show={showDeleteAlert}
                confirmBtnText="Yes, delete it!"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="light"
                title="Are you sure?"
                onConfirm={handleDeleteConfirm}
                onCancel={() => setShowDeleteAlert(false)}
            >
                You won't be able to revert this!
            </SweetAlert>

            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
        </React.Fragment>
    );
};

export default FAQ;